export const MIN_PLAGIARISM_AUDIT_WORD_COUNT = 50
